<template>
    <transition name="fade">
        <div class="details-wrapper page">
            <div class="secondary-header" v-if="!embeded">
                <div @click="() => { this.$router.push({path: '/vod'})}">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"> <path d="M15 6L9 12L15 18" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                    {{ this.type == 'movie' ? 'Movies' : 'Shows'}}
                </div>

                <div class="save" v-ripple @click="save">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="this.content.saved ? 'saved' : ''">
                        <path d="M5 21V5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V21L13.0815 17.1953C12.4227 16.7717 11.5773 16.7717 10.9185 17.1953L5 21Z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>

            <div class="loader-container" v-if="!ready" >
                <Loader />
            </div>

            <div class="details" :class="type">
                <div class="background">
                    <img :src="content.backdrop_path"/>

                    <div class="poster" v-if="type === 'movie'">
                        <img :src="content.poster_path"/>
                    </div>

                    <div v-else>
                        <h5 v-if="!editingTitle" v-touch:touchhold="startTitleEdit">
                            {{content.title || content.name}}
                            <b v-if="content.first_air_date && content.last_air_date"> ({{content.first_air_date.split('-')[0]}} - {{content.last_air_date.split('-')[0]}})   </b>
                            <b v-else> ({{content.first_air_date.split('-')[0]}})   </b>
                        </h5>
                        <div v-else class="title-edit">
                            <input ref="titleInput" class="title-input tv" type="text" v-model="titleDraft" @blur="commitTitleEdit" @keyup.enter="commitTitleEdit" @keyup.esc="cancelTitleEdit" />
                            <button v-if="hasCustomTitle" class="title-reset" @mousedown.prevent="resetTitle" @touchstart.prevent="resetTitle"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"> <path d="M1 4V10H7" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3.51 15A9 9 0 1 0 5.64 5.64L1 10" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg> </button>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="data-container" v-if="type == 'movie' && !detailsOnly">
                        <div class="streams" v-if="streams.length > 0"  v-touch:touchhold="() => { showDetails = !showDetails }" >
                            <div :key="i" class="stream" :class="streamErrors[i] ? 'error' : ''" v-ripple v-for="(s, i) in streams" @click="() => {playMedia(s.url, i)}" >
                                <svg v-if="streamErrors[i]" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"  class="error-icon" viewBox="0 0 24 24" fill="none"> <path d="M20.0429 21H3.95705C2.41902 21 1.45658 19.3364 2.22324 18.0031L10.2662 4.01533C11.0352 2.67792 12.9648 2.67791 13.7338 4.01532L21.7768 18.0031C22.5434 19.3364 21.581 21 20.0429 21Z" stroke="#e50914" stroke-width="1.5" stroke-linecap="round"/> <path d="M12 9V13" stroke="#e50914" stroke-width="1.5" stroke-linecap="round"/> <path d="M12 17.01L12.01 16.9989" stroke="#e50914" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M6.90588 4.53682C6.50592 4.2998 6 4.58808 6 5.05299V18.947C6 19.4119 6.50592 19.7002 6.90588 19.4632L18.629 12.5162C19.0211 12.2838 19.0211 11.7162 18.629 11.4838L6.90588 4.53682Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                {{s.quality}}
                                <div v-if="showDetails">
                                    <br/>
                                    {{s.filesize}}
                                    <br/>
                                    {{s.title}}
                                </div>

                            </div>
                        </div>

                        <div class="streams" v-else>
                            <p v-if="!streamsLoading">
                                No streams found
                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M8.5 14C8.22386 14 8 13.7761 8 13.5C8 13.2239 8.22386 13 8.5 13C8.77614 13 9 13.2239 9 13.5C9 13.7761 8.77614 14 8.5 14Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15.5 14C15.2239 14 15 13.7761 15 13.5C15 13.2239 15.2239 13 15.5 13C15.7761 13 16 13.2239 16 13.5C16 13.7761 15.7761 14 15.5 14Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M10 18H14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                            </p>

                            <div class="stream" v-else>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M15.5 15.5L19 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M5 11C5 14.3137 7.68629 17 11 17C12.6597 17 14.1621 16.3261 15.2483 15.237C16.3308 14.1517 17 12.654 17 11C17 7.68629 14.3137 5 11 5C7.68629 5 5 7.68629 5 11Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                Loading...
                            </div>
                        </div>
                    </div>

                    <div class="data-container" v-if="type == 'movie'">
                        <div class="data">
                            <h5 v-if="!editingTitle" v-touch:touchhold="startTitleEdit">
                                {{content.title || content.name}}
                                <b> ({{content.date.split('-')[0]}}) </b>
                            </h5>
                            <div v-else class="title-edit">
                                <input ref="titleInput" class="title-input" type="text" v-model="titleDraft" @blur="commitTitleEdit" @keyup.enter="commitTitleEdit" @keyup.esc="cancelTitleEdit" />
                                <button v-if="hasCustomTitle" class="title-reset" @mousedown.prevent="resetTitle" @touchstart.prevent="resetTitle"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"> <path d="M1 4V10H7" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3.51 15A9 9 0 1 0 5.64 5.64L1 10" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg> </button>
                            </div>

                            <div class="title-sup">
                                <span class="rating">
                                    <div v-for="(r, i) in ratings(content.vote_average*10)" :key="i" :class="r">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M8.58737 8.23597L11.1849 3.00376C11.5183 2.33208 12.4817 2.33208 12.8151 3.00376L15.4126 8.23597L21.2215 9.08017C21.9668 9.18848 22.2638 10.0994 21.7243 10.6219L17.5217 14.6918L18.5135 20.4414C18.6409 21.1798 17.8614 21.7428 17.1945 21.3941L12 18.678L6.80547 21.3941C6.1386 21.7428 5.35909 21.1798 5.48645 20.4414L6.47825 14.6918L2.27575 10.6219C1.73617 10.0994 2.03322 9.18848 2.77852 9.08017L8.58737 8.23597Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                    </div>
                                </span>

                            </div>
                            <p class="desc" > {{content.overview}} </p>
                            <div class="genres" v-if="content">
                                <div class="genre" v-for="(g, i) in content.genres" :key="i">
                                    {{g}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="data-container" v-else>
                        <div class="data ptop">
                            <div class="sselect">
                                <div v-for="(e,i) in new Array(content.number_of_seasons)" :key="i" @click="changeSeason(i + 1)" v-ripple>
                                    <div class="active" v-if="activeSeason === i + 1"> Season {{ i + 1 }}</div>
                                    <div v-else> {{ i + 1 }}</div>
                                </div>
                            </div>
                            <div class="eps">
                                <div class="cover-op" v-for="(e, i) in activeEpisodes" :key="i" v-ripple @click="changeEpisode(i+1)">
                                    <div v-if="e.still_path || (activeEpisodes[i].overview && activeEpisodes[i].name)">
                                        <img :src="'https://image.tmdb.org/t/p/w500/' + e.still_path"   @error="onImgError" />
                                        <div class="content">
                                            <small>
                                                <div class="red">
                                                    season {{activeSeason}}
                                                </div>
                                                <div>
                                                    episode {{i + 1}}
                                                </div>
                                            </small>
                                            <div class="summary">
                                                <span> <b>{{activeEpisodes[i].name}}</b> </span>
                                                <p> {{clampText(activeEpisodes[i].overview, 150)}} </p>
                                            </div>
                                        </div>
                                        <div class="check-mark" v-if="activeSeason < latestSeason || (activeSeason === latestSeason && (i ) < latestEpisode)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 0 24 24" fill="none"> <path d="M5 13L9 17L19 7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="title-wrapper" v-if="type == 'tv' && !detailsOnly">
                    <span> SEASON {{activeSeason}} EPISODE {{activeEpisode}} </span>

                    <div class="mode-selector" >
                        <div class="tab" :class="{ active: forceMode == 'query' }" @click="updateForceMode('query')"> query </div>
                        <div class="tab" :class="{ active: forceMode == 'filter' }" @click="updateForceMode('filter')"> filter </div>
                        <div class="tab" :class="{ active: forceMode == 'disc' }" @click="updateForceMode('disc')"> discog </div>
                    </div>
                </div>

                <div v-if="!detailsOnly">
                    <div class="data-container" v-if="type == 'tv' && !streamsLoading">
                        <div class="streams short" v-if="streams.length > 0"  v-touch:touchhold="() => { showDetails = !showDetails }" >
                            <div :key="i" class="stream" :class="streamErrors[i] ? 'error' : ''"  @click="playMedia(s.url, i)" v-ripple v-for="(s, i) in streams">
                                <svg v-if="streamErrors[i]" xmlns="http://www.w3.org/2000/svg" width="24px" height="24px"  class="error-icon" viewBox="0 0 24 24" fill="none"> <path d="M20.0429 21H3.95705C2.41902 21 1.45658 19.3364 2.22324 18.0031L10.2662 4.01533C11.0352 2.67792 12.9648 2.67791 13.7338 4.01532L21.7768 18.0031C22.5434 19.3364 21.581 21 20.0429 21Z" stroke="#e50914" stroke-width="1.5" stroke-linecap="round"/> <path d="M12 9V13" stroke="#e50914" stroke-width="1.5" stroke-linecap="round"/> <path d="M12 17.01L12.01 16.9989" stroke="#e50914" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M6.90588 4.53682C6.50592 4.2998 6 4.58808 6 5.05299V18.947C6 19.4119 6.50592 19.7002 6.90588 19.4632L18.629 12.5162C19.0211 12.2838 19.0211 11.7162 18.629 11.4838L6.90588 4.53682Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                {{s.quality}}
                                <div v-if="showDetails">
                                    <br/>
                                    {{s.filesize}}
                                    <br/>
                                    {{s.title}}
                                </div>
                            </div>
                        </div>

                        <div class="streams short" v-else>
                            <p>
                                No streams found
                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M8.5 14C8.22386 14 8 13.7761 8 13.5C8 13.2239 8.22386 13 8.5 13C8.77614 13 9 13.2239 9 13.5C9 13.7761 8.77614 14 8.5 14Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M15.5 14C15.2239 14 15 13.7761 15 13.5C15 13.2239 15.2239 13 15.5 13C15.7761 13 16 13.2239 16 13.5C16 13.7761 15.7761 14 15.5 14Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M10 18H14M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                            </p>
                        </div>
                    </div>

                    <div class="data-container" v-else-if="type == 'tv' && streamsLoading">
                        <div class="streams short" >
                            <div  class="stream">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M15.5 15.5L19 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M5 11C5 14.3137 7.68629 17 11 17C12.6597 17 14.1621 16.3261 15.2483 15.237C16.3308 14.1517 17 12.654 17 11C17 7.68629 14.3137 5 11 5C7.68629 5 5 7.68629 5 11Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                Loading...
                            </div>
                        </div>
                    </div>
                </div>

                <div class="data" v-if="content.credits && content.credits.cast && content.credits.cast.length > 0">
                    <h2 class="actor-space" :class="type"> Actors </h2>
                    <div class="content-row">
                        <MediaGroup v-for="(media, i) in content.credits.cast" :key="i + 'actors'" :media="media"/>
                    </div>
                </div>

                <div class="data" v-if="type=='movie' && content.credits && content.credits.crew">
                    <h2> Crew </h2>
                    <div class="content-row">
                        <MediaGroup v-for="(media, i) in content.credits.crew" :key="i + 'crew'" :media="media"/>
                    </div>
                </div>

                <div class="data" v-if="content.credits && content.credits.production && content.credits.production.length > 0">
                    <h2 v-if="type == 'movie'"> Production </h2>
                    <h2 v-else> Network </h2>

                    <div class="content-row">
                        <MediaGroup  v-for="(media, i) in content.credits.production" :key="i" :media="media"/>
                    </div>
                </div>

                <div class="data" v-if="!detailsOnly">
                    <h2> More Like {{content.title || content.name}} </h2>
                    <div v-if="ready" class="content-row" @scroll="(e) => {handleScroll(e.target)}"  >
                        <Movie v-ripple v-for="(content, i) in content.reccomended" :key="i" :media="content" :list="true" :display="true" />
                    </div>
                </div>

            </div>

            <transition name="fade">
                <div class="next-episode-loader" v-if="nextEpisodeLoading">
                    <div class="content">
                        <Loader />
                        <div>
                            <b> UP NEXT </b>
                            <span>
                                {{content.title || content.name}} Season {{activeSeason}} Episode {{activeEpisode}}
                            </span>
                        </div>
                    </div>
                </div>
            </transition>

            <AYSTW
                :show="stillWatchingPrompt"
                :yes="confirmStillWatching"
                :no="cancelStillWatching"
            />
        </div>
    </transition>
</template>

<script>
const AYSTW = () => import('@/components/theater/AYSTW.vue')
const MediaGroup = () => import('@/components/MediaGroup.vue')
const Movie = () => import('@/components/Movie.vue')
const Loader = () => import('@/components/Loader')

export default {
  name: 'Details',

  components: {
    AYSTW,
    Loader,
    Movie,
    MediaGroup
  },

  props: {
        embeded: Boolean,
        detailsOnly: Boolean,
        contentId: Number,
        contentType: String
  },

  watch: {
      $route() {
        this.forceMode = null
        this.editingTitle = false
        this.linkIndex = 0
        this.latestSeason = 0
        this.latestEpisode = 0
        this.stillWatchingPrompt = false
        this.userActivityTimeout = null
        this.stillWatchingTimeout = null
        this.userActivityTimeoutPaused = false
        this.streamsLoading = true
        this.ready = false
        this.content = null
        this.activityTimeoutLength = (60000 * 60)
        this.streams = []
        this.streamErrors = []
        this.reccomendedLoading = false
        this.loadDetails()
      }
  },

  data: function(){
    return {
        ready: false,
        streamsLoading: true,

        loading: false,
        reccomendedLoading: false,

        content: null,
        forceMode: null,
        showDetails: false,

        editingTitle: false,
        titleDraft: '',
        originalTitle: '',
        hasCustomTitle: false,

        streams: [],
        streamErrors: [],
        activeEpisodes: [],
        activeEpisode: 1,
        activeSeason: 1,
        latestSeason: 0,
        latestEpisode: 0,

        reccomendedPage: 2,
        linkIndex: 0,
        nextEpisodeLoading: false,

        stillWatchingPrompt: false,
        userActivityTimeout: null,
        stillWatchingTimeout: null,
        activityTimeoutLength: (60000 * 60),
        userActivityTimeoutPaused: false,
    }
  },

    methods: {

    onImgError(event) {
        event.target.src = 'http://cdn.studio14a.com/QB/card-fallback.jpg'
    },

    startTitleEdit(){
        this.titleDraft = this.content.title || this.content.name
        this.editingTitle = true
        this.$nextTick(() => {
            if(this.$refs.titleInput){
                this.$refs.titleInput.focus()
                this.$refs.titleInput.select()
            }
        })
    },

    cancelTitleEdit(){
        this.editingTitle = false
    },

    commitTitleEdit(){
        if(!this.editingTitle){ return }
        this.editingTitle = false

        const value = this.titleDraft.trim()
        if(!value || !this.content || value === (this.content.title || this.content.name)){ return }

        if(this.content.title !== undefined){ this.content.title = value }
        if(this.content.name !== undefined){ this.content.name = value }
        document.title = `${value} - QB`

        const storedTitles = JSON.parse(localStorage.getItem('customTitles')) || {}
        storedTitles[this.content.id] = value
        localStorage.setItem('customTitles', JSON.stringify(storedTitles))
        this.hasCustomTitle = true

        this.loadDetails()
    },

    resetTitle(){
        this.editingTitle = false

        if(!this.content || !this.hasCustomTitle){ return }

        const storedTitles = JSON.parse(localStorage.getItem('customTitles')) || {}
        delete storedTitles[this.content.id]
        localStorage.setItem('customTitles', JSON.stringify(storedTitles))
        this.hasCustomTitle = false

        if(this.content.title !== undefined){ this.content.title = this.originalTitle }
        if(this.content.name !== undefined){ this.content.name = this.originalTitle }
        document.title = `${this.originalTitle} - QB`
        this.loadDetails()
    },

    clearStillWatchingTimeouts(){
         if(this.userActivityTimeout){
            clearTimeout(this.userActivityTimeout);
        }
        if(this.stillWatchingTimeout){
            clearTimeout(this.stillWatchingTimeout);
        }
        this.userActivityTimeout = null;
        this.stillWatchingTimeout = null;

    },
    theaterClosed() {
        this.stillWatchingPrompt = false;
        this.clearStillWatchingTimeouts()
    },
    cancelStillWatching(){
        this.stillWatchingPrompt = false;
        this.$root.$emit('closeTheater');
        this.clearStillWatchingTimeouts()
    },

    confirmStillWatching() {
        this.activityTimeoutLength = 60000 * 90
        this.stillWatchingPrompt = false;
        this.resetUserActivityTimeout();
        this.$root.$emit('playerEvent', 'play');
    },

    resetUserActivityTimeout() {
        this.clearStillWatchingTimeouts()
        this.userActivityTimeout = setTimeout(() => {
            this.stillWatchingPrompt = true;
            this.stillWatchingTimeout = setTimeout(() => {
                this.$root.$emit('playerEvent', 'pause');
            }, 120000);
        }, this.activityTimeoutLength); // 60 minutes -> 90
    },

    theaterEventOccured(pause=false){
        if((this.userActivityTimeout && this.stillWatchingTimeout) || this.userActivityTimeoutPaused) {
            if(pause){
                this.clearStillWatchingTimeouts()
                this.userActivityTimeoutPaused = true
            }else{
                this.resetUserActivityTimeout();
                this.userActivityTimeoutPaused = false
            }
        }
    },

    async playNextEpisode() {
        if(this.userActivityTimeout === null && this.stillWatchingTimeout === null) {
            this.resetUserActivityTimeout();
        }

        this.nextEpisodeLoading = true

        await this.loadDetails(false)

        //very sad hack
        const timeout = Date.now() + 60000
        while(!this.streams || this.streams.length === 0) {
            if(Date.now() > timeout) {
                console.error('Timeout: No streams found after 60 seconds')
                this.nextEpisodeLoading = false
                return
            }
            await new Promise(resolve => setTimeout(resolve, 100))
        }

        this.$nextTick(() => {
            if(this.streams && this.streams[this.linkIndex].url){
                this.playMedia(this.streams[this.linkIndex].url, this.linkIndex)

                this.$nextTick(() => {
                    this.$root.$emit('wod', {mode: 'od', last: this.isLastEp() })
                    this.$nextTick(() => {
                        setTimeout(() => { this.nextEpisodeLoading = false }, 2000)
                    })
                })
            }else{
                //link index shifted maybe try zero
                if(!this.streams || this.streams.length === 0){
                    setTimeout(() => { this.nextEpisodeLoading = false }, 2000)
                }else{
                    //use first link otherwise
                    this.playMedia(this.streams[0].url, 0)
                    this.$nextTick(() => {
                        this.$root.$emit('wod', {mode: 'od', last: this.isLastEp() })
                        this.$nextTick(() => {
                            setTimeout(() => { this.nextEpisodeLoading = false }, 2000)
                        })
                    })

                }
            }
        })

  },

  streamErrored(){
    this.$set(this.streamErrors, this.linkIndex, true)
  },

  async handleScroll(container) {
      const isAtEnd = container.scrollLeft + container.clientWidth >= (container.scrollWidth - 775);
      if (isAtEnd && !this.reccomendedLoading) {
        this.reccomendedLoading = true
          const showresponse  = await window.afetch(`/reccomended`, {
                method: 'POST',
                body: JSON.stringify({
                    page: this.reccomendedPage,
                    id: this.id,
                    type: this.type,
                })
            })
            const showData =  await showresponse.json()
            this.content.reccomended = [...this.content.reccomended, ...showData]
            this.reccomendedPage = this.reccomendedPage + 1
        this.reccomendedLoading = false
      }
    },

    updateForceMode(m){
        if(this.forceMode === m){
            this.forceMode = null
            return
        }
        this.forceMode = m

        this.$nextTick(() => {
            this.changeEpisode(this.activeEpisode)
        })
    },

    clampText(text, maxLength) {
        if (text.length <= maxLength) {
            return text;
        } else {
            return text.substring(0, maxLength - 3) + '...';
        }
    },

    loadDetails: async function(full=true){
        if(full){
            window.showId = this.id

            this.ready = false;
            this.recommendedPage = 2

            this.streamErrors = []
            if(!this.embeded){
            this.$nextTick(() => { window.scrollTo({top: 0, behavior: 'smooth'}); })
            }

            const response  = await window.afetch(`/details?id=${this.id}&type=${this.type}`)
            this.content =  await response.json()
            this.originalTitle = this.content.title || this.content.name

            this.ready = true

            const storedTitles = JSON.parse(localStorage.getItem('customTitles')) || {}
            this.hasCustomTitle = !!storedTitles[this.content.id]
            if(this.hasCustomTitle){
                if(this.content.title !== undefined){ this.content.title = storedTitles[this.content.id] }
                if(this.content.name !== undefined){ this.content.name = storedTitles[this.content.id] }
            }

            this.setTab()
        }

        if(this.type == 'tv'){
            this.activeEpisodes = this.content.season.episodes

            const storedList = JSON.parse(localStorage.getItem('WODHistory')) || [];
            const storedEntry = storedList.find(item => item.id == this.content.id);

            let chosenSeason = this.content.history?.season || 0;
            let chosenEpisode = this.content.history?.episode || 0;


            if(storedEntry){
                this.latestEpisode = parseInt(storedEntry.episode)
                this.latestSeason = parseInt(storedEntry.season)
                await this.changeSeason(this.latestSeason, false);
                await this.$nextTick()
            }

            if (storedEntry && (storedEntry.season && storedEntry.season > chosenSeason) || (storedEntry && storedEntry.episode > chosenEpisode)) {
                chosenEpisode = storedEntry.episode;
                chosenSeason = storedEntry.season;
            }
            if (chosenEpisode > 0) {
                let nextSeason = chosenSeason;
                let nextEpisode = chosenEpisode + 1;

                if (nextEpisode > this.activeEpisodes.length) {
                    if (chosenSeason < this.content.number_of_seasons) {
                        nextSeason = chosenSeason + 1;
                        nextEpisode = 1;
                    } else {
                        nextSeason = chosenSeason;
                        nextEpisode = chosenEpisode;
                    }
                }

                await this.changeSeason(nextSeason, full);
                await this.changeEpisode(nextEpisode);

            }else{
                await this.changeSeason(1, false)
                await this.changeEpisode(1)
            }
        }else{
            await this.loadMovieStreams()
        }
    },

   async loadMovieStreams(){
        if(this.detailsOnly){return}
        this.streamErrors = []
        const params = new URLSearchParams({
            title: this.content.title,
            type: this.type,
            year: this.content.year,
            id: this.id,
        });

        const response = await window.afetch(`/streams?${params}`);
        const data = await response.json()
        this.streams =  data.streams
        this.streamsLoading = false
    },

    async loadShowStreams(mode){
        if(this.detailsOnly){return}
        this.streamErrors = []

        if(this.forceMode){
            mode = this.forceMode
        }else{
            if(!mode){
                mode = this.content.in_production ? 'query' : 'filter'
                this.forceMode = mode
            }
        }

        const params = new URLSearchParams({
            mode,
            title: this.content.name,
            type: this.type,
            e: this.activeEpisode,
            s: this.activeSeason,
            count: this.content.number_of_episodes,
            id: this.id,
        });

        const response = await window.afetch(`/streams?${params}`);

        const data = await response.json()
        this.streams =  data.streams
        this.streamsLoading = false
    },

    ratings(rating) {
        const stars = []
        const rating5 = rating / 20

        for (let i = 0; i < Math.floor(rating5); i++) {
            stars.push('whole')
        }

        if (rating5 % 1 >= 0.5) {
            stars.push('half')
        }

        return stars
    },

    async changeEpisode(ep){
        this.activeEpisode = ep
        window.episode = this.activeEpisode
        this.streamsLoading = true
        this.streams = []
        await this.loadShowStreams()

        if(ep !== 1){
            this.$nextTick(() => {
                setTimeout(() => {
                    document.querySelectorAll('.cover-op')[ep - 1].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center", })
                }, 500)
            })
        }
    },

    async changeSeason(season, force=true){
        if(force){
            this.forceMode = null
        }
        const response  = await window.afetch(`/season?id=${this.id}&type=${this.type}&season=${season}`)
        const data =  await response.json()
        this.activeEpisodes = data.episodes
        this.activeSeason = season
        if(force){ this.changeEpisode(1) }
        window.season = this.activeSeason
        this.streams = []
    },

    async save(){
        let data = {
            type: 'od',
            id: `${this.id}`,
            ref: `${window.location.origin}/${this.type}/${this.id}`,
            name: (this.content.title || this.content.name),
            imgs: [this.content.poster_path, this.content.backdrop_path],
            contentType: this.type,
            date: this.date
        }

        const req = await window.afetch(`/save`, {method: 'POST', body: JSON.stringify(data) })
        const res = await req.json()
        this.content.saved = res.saved
    },

    isLastEp(){
        if(this.content && this.activeSeason === this.content.number_of_seasons){
            if(this.activeEpisode === this.activeEpisodes.length){
                return true
            }
        }
        return false
    },


    playMedia: function(mag, index){
        this.linkIndex = index

        if(!window.did){
            this.$root.$emit('collectDid', {
                cb: this.playMedia.bind(this),
                params: {
                    url: mag,
                    last: this.isLastEp(),
                    title: this.content.title || this.content.name,
                    artwork: this.content.poster_path,
                    season:  this.type == 'tv' ? this.activeSeason : null,
                    episode: this.type == 'tv' ? this.activeEpisode : null,
                }
            })
            return
        }

        let data = {
            type: 'od',
            id: `${this.id}`,
            did: window.did,
            ref: `${window.location.origin}/${this.type}/${this.id}`,
            url: mag,
            name: (this.content.title || this.content.name),
            logos: [this.content.poster_path, this.content.backdrop_path],

            details: {
                contentType: this.type,
                actors: this.content.credits.cast.slice(0,5),
                genres: this.content.genres,
            }
        }

        data.details.date = this.content.date.split('-')[0]

        if(this.type == 'movie'){
            data.details.runtime = this.content.runtime || 75
        }else{
            data.details.episode = this.type == 'movie' ? 0 : this.activeEpisode
            data.details.season = this.type == 'movie' ? 0 : this.activeSeason
            data.details.runtime = this.content.episode_run_time[0] || 30
            data.details.img = 'https://image.tmdb.org/t/p/w500/' +  this.activeEpisodes[this.activeEpisode - 1].still_path
            data.details.mode = this.forceMode
            data.details.index = this.linkIndex
        }

        window.afetch(`/start`, {method: 'POST', body: JSON.stringify(data) })
    },
    setTab(){
        if(!this.embeded){
            document.title = `${this.content.title || this.content.name} - QB`
        }

    }
  },


computed: {
    id: function(){
        if(this.contentId){
            return this.contentId
        }
        return this.$route.params.id
    },

    type: function(){
        if(this.contentType){
            return this.contentType
        }

        if(window.location.href.includes('movie')){
            return 'movie'
        }else{
            return 'tv'
        }
    }

  },

    mounted: async function(){
        if(this.type === 'movie'){
            window.episode = 0
            window.season = 0
        }
        await this.loadDetails()
        this.$root.$on('nextEpisode', this.playNextEpisode);
        this.$root.$on('theaterClosed', this.theaterClosed);
        this.$root.$on('theaterEvent', this.theaterEventOccured);
        this.$root.$on('streamError', this.streamErrored);
    },

    activated: function(){
        this.setTab()
    },

    beforeDestroy() {
        this.$root.$off('nextEpisode', this.playNextEpisode);
        this.$root.$off('theaterClosed', this.theaterClosed);
        this.$root.$off('theaterEvent', this.theaterEventOccured);
        this.$root.$on('streamError', this.streamErrored);
    },
}

</script>

<style scoped lang="scss">
.loader-container{
    position: fixed;
    top: 0px;
    left: 0;
    z-index: 9;
    background-color: #111;
    width: 100%;
    height: 100%;
}
.actor-space{
    &.movie{
        padding-top: 0px;
    }
    &.tv{
        padding-top: 20px;
    }
}
.details{
    .content{
        position: relative;
        width: 100%;
    }


    .data{
        h2{
            padding-left: 20px;
        }

        h4{ margin-bottom: 0; }
    }
    .title-sup{
        width: 100%;
        margin: 10px 0;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        > div {
            display: flex;
            flex-direction: column;
        }
        button{
            padding: 10px 20px;
            font-size: 9pt;
            margin-bottom: 10px;
            font-weight: bold;
            border-radius: 4px;
            outline: none;
            color: white;
            border: none;
            background-color: rgba(white, 0.1);
        }
    }

    .rating{
        color: white;
        display: flex;
        opacity: 0.5;

        > div{
            position: relative;
            width: 20px;
            height: 20px;
            overflow: hidden;
            margin-right: 4px;
            &.half{
                width: 10px;
            }
        }
        svg{
            position: absolute;
            top: 0;
            left: 0;
            fill: white;
            width: 20px;
            height: 20px;
        }
    }

    .eps{
        width: calc(100% + 40px);
        overflow: scroll;
        display: flex;
        flex-direction: row;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .cover-op{
        position: relative;
        padding-left: 20px;
        .check-mark{
            position: absolute;
            top: 0;
            right: 0;
            margin: 10px;
            padding: 5px;
            background-color: rgba(46, 204, 113, 0.7);
            border-radius: 50%;
            width: 10px;
            color: white;
            height: 10px;
            text-align: center;
            font-size: 10px;
            backdrop-filter: blur(20px);
        }
        &:last-of-type{
            padding-right: 20px;
        }
        img {
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        .summary{
            width: calc(90% - 10px);
            padding: 10px;
            backdrop-filter: blur(20px);
            background-color: rgba(255,255,255,0.1);
            margin-bottom: 10px;
            text-overflow: ellipsis;
            overflow: hidden;
            border-radius: 10px;

        }
        >div{
            width: 375px;
            position: relative;
            min-height: 300px;
            overflow: hidden;
            border-radius: 8px;
        }

        .content{
            z-index: 8;
            padding-left: 10px;
            padding-right: 10px;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            position: absolute;
            background-color: rgba(0,0,0,0.2);

            .badge{
                position: absolute;
                color: white;
                bottom: 20px;
                right: 20px;
                display: flex;
                font-size: 9pt;
                svg{
                    color: white;
                    width: 13px;
                    padding-right: 5px;
                }
            }
            h4, p{
                margin: 0;
                padding: 0;
            }

            p{
                font-size: 9px;
                padding: 20px 0;
                width: 100%;
            }

            h4{
                margin-top: 20px;
                margin-bottom: 20px;
                font-size: 14pt;
            }

            small{
                display: block;
                margin-top: 10px;
                text-transform: uppercase;
                font-size: 7pt;
                font-weight: bold;
                display: flex;
                text-shadow: 0 0px 13px rgba(0, 0, 0, 0.85);
                .red{
                    color: #e74c3c;
                    padding-right: 10px;
                }
            } .ep-data{
                color: white;
                margin: 20px;
                width: 85%;

            }
            span{
                right: 20px;
                font-size: 7pt;
                padding-bottom: 20px;
                top: 20px;
                color: white;
                font-weight: bold;

            }
        }
    }

    .data-container{
        display: flex;
        color: white;
        width: 100%;

        p{
            line-height: 1.75;
            width: 100%;
            font-size: 10pt;
            text-align: justify;
        }
        .genres{
            padding: 10px 0;
            display: flex;
            flex-wrap: wrap;
            .genre{
                margin: 8px 4px;
                padding: 10px 15px;
                border-radius: 12px;
                transition: all 300ms ease;
                font-size: 9pt;
                border: 1px solid transparent;
                background-color: rgba(white, 0.1);
                border-radius: 90px;
            }
        }
        .data{
            width: calc(100% - 40px);
            padding: 20px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            &.ptop{ padding: 0; }

            span{
                margin: 0;
                padding: 0;
                font-size: 11pt;
                padding-bottom: 10px
            }
        }
    }

    h5{
        font-size: 16pt;
        text-transform: uppercase;
        margin: 0;
        text-overflow: wrap;
        font-weight: bold;
        padding-top: 20px;
        padding-bottom: 0px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        b{
            display: block;
            font-size: 9pt;
            padding-top: 5px;
            padding-left: 20px;
            opacity: 0.5;
        }
    }

    .title-input{
        font-family: inherit;
        font-size: 16pt;
        font-weight: bold;
        text-transform: uppercase;
        color: white;
        background-color: rgba(white, 0);
        border: none;
        border-bottom: 1px solid rgba(white, 0.35);
        border-radius: 0px;
        outline: none;
        box-sizing: border-box;
        display: block;
        width: 100%;
        margin: 0;
        padding: 20px 10px 6px;
        padding-bottom: 20px;

        &.tv{
            position: relative;
            z-index: 2;
            font-size: 26pt;
            padding: 85px 20px;
            width: 70%;
            border-radius: 0;
            padding-bottom: 20px;
            text-align: left;
        }
    }

    .title-edit{
        display: flex;
        align-items: center;

        .title-input{
            flex: 1;
            min-width: 0;
        }

        .title-reset{
            flex-shrink: 0;
            margin-left: 10px;
            margin-right: 20px;
            padding: 8px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            outline: none;
            color: white;
            border: none;
            background-color: rgba(white, 0.1);
            z-index: 9;
            margin-top: 40px;

            svg{
                display: block;
                width: 16px;
                height: 16px;
            }
        }
    }

    .background{
        width: 100%;
        height: 350px;
        margin-bottom: 200px;
        position: relative;
        border-bottom-right-radius: 15px;
        border-bottom-left-radius: 15px;
        .content{
            height: 30px;
            padding-left: 20px;
            top: calc(35% - 60px);
        }

        > img{
            filter: blur(25px);
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0%;
            left: 0%;
            object-fit: cover;
            border-bottom-right-radius: 15px;
            border-bottom-left-radius: 15px;

        }
        .poster{
            position: absolute;
            top: 100px;
            left: 50%;
            transform: translateX(-50%);
            width: 90%;
            max-width: 275px;
            height: auto;
            z-index: 9;
            img{
                width: 100%;
                border-radius: 15px;
                overflow: hidden;
                height: auto;
                box-shadow: -3px 3px 12px 2px rgba(0, 0, 0, 0.5);
            }
        }
    }


    &.tv{
        .background{
            height: 275px;
            margin-bottom: 0px;
            overflow: hidden;
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
            &::before{
                pointer-events: none;
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                z-index: 1;
                background: linear-gradient(0deg, rgba(#141414,1) 0%, rgba(#141414,0.84) 30%, rgba(#141414, 0) 100%);
            }
        }
        h5{
            position: relative;
            font-size: 26pt;
            padding: 85px 20px;
            width: 70%;
            text-align: left;
            z-index: 2;
            flex-wrap: wrap;
            justify-content: flex-start;
            b{
                min-width: 100%;
                flex-grow: 1;
                padding-left: 0;
            }
        }

        .background > img{
            filter: none;
            opacity: 75;
            object-fit: cover;
            top: 0;
            min-width: 100%;
            min-height: 200px;
            width: auto;
            height: auto;
        }
    }

}

.data-container.no-flex{
    display: block;
    padding-bottom: 40px;
    min-height: 75px;
}
.title-wrapper{
    display: flex;
    justify-content: space-between;
    width: 100%;
    span{
        font-weight: bold;
        padding-left: 20px;
    }
    .mode-selector{
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 9px;
        padding: 0 20px;

        .tab{
            margin-left: 10px;
            background: white;
            color: black;
            border-radius: 3px;
            padding: 2px 4px;

            &.active{
                background: red;
                color: white;
            }
        }

    }
}

.data-container .streams, .data-container .stream{
    display: flex;
    flex-direction: row;
    padding-left: 20px;
    overflow-x: scroll;
    align-items: center;
    min-height: 75px;
    padding-top: 20px;
    &.streams{
        width: 100%;
        .stream{
            width: auto;
            > div{
                padding: 0 10px;
                text-wrap: break-word;
            }
            &.short{
                padding-top: 20px;
                width: 100%;
            }
        }
    }
    > p{
        border: 1px solid white;
        width: calc(100% - 40px);
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 10px 0;
        border-radius: 3px;
        svg{
            margin: 0;
            padding: 0;
            padding: 5px;
        }
    }
    small{
        padding-top: 5px;
    }
    svg{
        height: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .stream{
        font-size: 9px;
        border: 1px solid white;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #111;
        margin-right: 10px;
        padding: 5px 10px;
        padding-bottom: 10px;
        box-sizing: border-box;
        border-radius: 5px;
        min-width: 100px;
        overflow: hidden;
        text-align: center;
        position: relative;

        &.error{
            //opacity: 0.5;
            border-color: #e50914;
            color: #e50914;
        }
    }
}

.sselect{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 10px 20px;
    margin-top:  0px;
    width: 100%;
    >div{
        margin-right: 10px;
        margin-bottom: 10px;

        >div{
            padding: 1px 5px;
            border-radius: 5px;
        }

        > div:not(.active){
            border: 1px solid white;
        }
    }
    .active{
        background-color: red;
        min-width: 85px;
        text-align: center;
        padding: 2px 5px;
    }
}

.next-episode-loader{
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: fixed;
    z-index: 99999999;
    background-color: #141414;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    .loader{
        position: relative!important;
        top: 0;
        right: 0;
    }
    .content{
        display: flex;
        align-items: center;
    }

    b{
        font-weight: bolder;
        font-size: 14px;
        color: #e50914;
        padding-bottom: 6px;
    }
    span,b {
        padding-left: 48px;
        display: block;
    }
}

</style>
